<template>
  <div id="GroupSchoolFeeReport">
    <div class="container">
      <div style="background: white">
        <K2Row justify_content="center" class="position-relative p-4">
          <K2Heading type="h5" class-name="mb-0" color="black">GROUP SCHOOL FEE REPORT</K2Heading>
        </K2Row>
      </div>

      <div style="background: white" class="position-relative p-4">
        <K2Row class="">
          <K2Row align="center" class="me-2 search-wrap">
            <span class="label-control me-2">School Group</span>
            <el-select v-model="ddlSchools" placeholder="Filter By School Group" class="search-wrap" @change="getAcademiYearsByGroup()">
              <el-option v-for="item in schoolList" :key="item.SchoolGroup" :label="item.SchoolGroup" :value="item.SchoolGroup"> </el-option>
              <!--<el-option
                                      key="Pre-School"
                                      label="Pre-School"
                                      value="Pre-School">
                              </el-option>
                              <el-option
                                      key="International School"
                                      label="International School"
                                      value="International School">
                              </el-option>
                              <el-option
                                      key="Middleton"
                                      label="Middleton"
                                      value="Middleton">
                              </el-option>-->
            </el-select>

            &nbsp; &nbsp; &nbsp;

            <span class="label-control me-2">Academic Year</span>
            <el-select v-model="ddlAcademicYear" placeholder="Filter By Academic Year" class="search-wrap">
              <el-option v-for="item in semesterList" :key="item.AcademicYear" :label="item.AcademicYear" :value="item.AcademicYear"> </el-option>
            </el-select>

            &nbsp; &nbsp; &nbsp;

            <K2Button :background="uiVariable.color.button2" size="small" @onclick="handleFilter('search')">
              {{ lang('Search') }}
            </K2Button>

            &nbsp;

            <K2Button :background="uiVariable.color.secondary" size="small" @onclick="handleClear()">
              {{ lang('Clear') }}
            </K2Button>
          </K2Row>
        </K2Row>

        <K2Row class="text-left">
          <K2Button size="small" theme="2" @onclick="handleFilter('export')" class="text-left">
            {{ lang('Export') }}
          </K2Button>
        </K2Row>

        <div>&nbsp;</div>

        <b-card no-body>
          <div v-if="fullListByClassNameObj.length > 0" class="datatable_group col-lg-12">
            <div class="datatable-form__submit text-left">
              <!--<button class="btn btn-success text-left" id="btnClassOverviewDownloadAll" v-on:click="DownloadAllClick(-1, 'All')">Download All</button><br><br>-->
            </div>

            <div v-for="(classBatchItem, i) in fullListByClassNameObj">
              <!--<label>Batch: {{classBatchItem[i].CLS_batch}}</label>-->
              <data-tables :data="classBatchItem">
                <el-table-column
                  v-for="studentItem in classBatchItemList"
                  :prop="studentItem.prop"
                  :label="studentItem.label"
                  :key="studentItem.prop"
                  sortable="custom"
                >
                </el-table-column>
              </data-tables>
            </div>
          </div>

          <div class="empty-list_image" v-if="fullListByClassNameObj.length < 1">
            <img src="../../assets/notfound.png" />
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx'

import K2Heading from '../../uiComponents/k2Heading/k2Heading'
import K2Row from '../../uiComponents/k2Row/k2Row'

import K2Button from '../../uiComponents/k2Button/k2Button'

import uiVariable from '../../config/uiVariable'
import DataSource from '@/data/datasource'
import { lang } from '@/locale'
import Cookies from 'js-cookie'

import Export_CSV from '@/components/Export_CSV'
import { getFormatDate } from '@/helper/utily'

export default {
  name: 'GroupSchoolFeeReport',
  components: { K2Heading, K2Row, K2Button },
  data() {
    return {
      uiVariable: uiVariable,
      selectedTab: 0,
      filterList: [
        {
          label: 'Schools',
          placeholder: 'Filter by Schools',
          optionList: [],
        },
        {
          label: 'AcademicYear',
          placeholder: 'Filter by AcademiYear',
          selected: [],
        },
      ],
      conUserId: '',
      ddlSchools: '',
      ddlAcademicYear: '',
      schoolList: [],
      semesterList: [],
      fullListByClassNameObj: [],
      fullListByClassNameObj2: [],
      classBatchItemList: [
        {
          prop: 'FeeSchemeName',
          label: 'Fee Scheme Name',
        },
        {
          prop: 'ItemType',
          label: 'Item Type',
        },
        {
          prop: 'ItemName',
          label: 'Item Name',
        },
        {
          prop: 'AmountwithoutGST',
          label: 'Amount without GST',
        },
        {
          prop: 'School',
          label: 'School',
        },
      ],

      detailList: [],
      relationshipDetailList: [],
      selectedSchool: null,
      selectedAcademic: null,
      selectedClass: null,
      dateRange: null,
      dateType: 'daterange',
    }
  },
  mounted() {
    this.init()
    this.conUserId = Cookies.get('userIDSession')
  },
  methods: {
    lang,
    async init() {
      await this.getSchoolGroups()
      await this.getAcademiYearsByGroup()
    },
    onFilterChange(value) {
      this.getClass(value)
    },

    handleFilter(type) {
      if (this.ddlSchools == '' || this.ddlSchools == undefined) {
        this.$notify.error({
          title: 'Error',
          message: 'Please select a school',
        })
        return
      }

      if (this.ddlAcademicYear == '' || this.ddlSchools == undefined) {
        this.$notify.error({
          title: 'Error',
          message: 'Please select the academic year',
        })
        return
      }

      if (type == 'search') {
        this.loadReport()
      } else {
        //alert(this.fullListByClassNameObj.length);

        if (this.fullListByClassNameObj.length == 0) {
          this.$notify.error({
            title: 'Error',
            message: 'No data to export',
          })
          return
        } else {
          this.handleExport()
        }
      }
    },

    async getSchoolGroups() {
      try {
        const response = await DataSource.shared.getSchoolGroupDropdownListByUser('UTY201300000061')
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.schoolList = response.Table
          }
        }
      } catch (e) {
        console.log('error getSchoolGroups')
      }
    },

    async getAcademiYearsByGroup() {
      try {
        this.ddlAcademicYear = ''
        const response = await DataSource.shared.getAllAcademicYearsByGroup(this.ddlSchools)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.semesterList = response.Table
          }
        }
      } catch (e) {
        console.log('error getAcademiYearsByGroup')
      }
    },

    async handleClear() {
      this.ddlSchools = undefined
      this.semesterList = []
      this.ddlAcademicYear = undefined
      this.fullListByClassNameObj = []
      this.fullListByClassNameObj2 = []
    },

    async loadReport() {
      this.$vs.loading()

      try {
        this.fullListByClassNameObj = []
        this.fullListByClassNameObj2 = []

        const resp = await DataSource.shared.GetGroupSchoolFeeReport1(this.ddlSchools, this.ddlAcademicYear)
        //console.log(resp);
        if (resp) {
          if (resp.Table) {
            this.fullListByClassNameObj.push(resp.Table)
          }
        }
      } catch (e) {
        console.log('error loadReport GetGroupSchoolFeeReport1', e)
      }
      try {
        const resp = await DataSource.shared.GetGroupSchoolFeeReport2(this.ddlSchools, this.ddlAcademicYear)
        //console.log(resp);
        if (resp) {
          if (resp.Table) {
            this.fullListByClassNameObj2.push(resp.Table)
            //console.log(this.fullListByClassNameObj2);
          }
        }
      } catch (e) {
        console.log('error loadreport GetGroupSchoolFeeReport2', e)
      }
      this.$vs.loading.close()
    },

    async handleExport() {
      let exportExcelObject = []
      let exportExcelObject2 = []

      var title = this.ddlSchools + '-' + this.ddlAcademicYear

      var currentDateWithFormat = new Date().toJSON().slice(0, 10).replace(/-/g, '/')

      var mergedArrNormalWay = []

      this.fullListByClassNameObj.forEach(o => {
        o.forEach(so => mergedArrNormalWay.push(so))
      })

      mergedArrNormalWay.forEach(n => {
        let list = {
          'Fee Scheme Name': n.FeeSchemeName,
          'Item Type': n.ItemType,
          'Item Name': n.ItemName,
          'Amount without GST': n.AmountwithoutGST,
          School: n.School,
        }
        exportExcelObject.push(list)
      })

      var sheet1WS = XLSX.utils.json_to_sheet(exportExcelObject)
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, sheet1WS, 'sheet1') // sheetAName is name of Worksheet
      XLSX.writeFile(wb, 'School Group Fee Master - ' + currentDateWithFormat + ' - ' + title + '.xlsx') // name of the file is 'book.xlsx'

      ////////////////////////////////

      var mergedArrNormalWay2 = []

      //console.log(this.fullListByClassNameObj2);

      this.fullListByClassNameObj2.forEach(o => {
        o.forEach(so => mergedArrNormalWay2.push(so))
      })

      mergedArrNormalWay2.forEach(n => {
        let list2 = {
          'Fee Scheme Name': n.FeeSchemeName,
          'Item Description': n.ItemDescription,
          'Item Name': n.ItemName,
          'Item Type': n.ItemType,
          'Amount without GST': n.AmountwithoutGST,
          Category: n.Category,
          'Time Line': n.TimeLine,
          School: n.School,
        }
        exportExcelObject2.push(list2)
      })

      var sheet1WS2 = XLSX.utils.json_to_sheet(exportExcelObject2)
      var wb2 = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb2, sheet1WS2, 'sheet1') // sheetAName is name of Worksheet
      XLSX.writeFile(wb2, 'School Group Fee Pro Rate - ' + currentDateWithFormat + ' - ' + title + '.xlsx') // name of the file is 'book.xlsx'

      /* let finalExportList = [];
      if (this.detailList.length > 0) {
        let add1 ="";
        let add2 ="";
        let add3 ="";
        this.detailList.forEach((m, index) => {
          if (m.address_1){
            add1 = m.address_1 ;
          }
          if (m.address_2){
            add2 = m.address_2 ;
          }
          if (m.address_3){
            add3 = m.address_3 ;
          }
          let tempRow = {
            'reference ': m.reference,
            'user_groups ': m.user_groups,
            'Title': m.Title,
            'first_name': m.first_name,
            'Last_name': m.Last_name,
            'maiden_name': m.maiden_name,
            'Middle_name': m.Middle_name,
            'preferred_first_name': m.preferred_first_name,
            'suffix_1': m.suffix_1,
            'DOB': m.DOB,
            'from': m.from,
            'to': m.to,
            'gender': m.gender,
            'class_of': m.class_of,
            'start_year_group': m.start_year_group,
            'end_year_group': m.end_year_group,
            'house': m.house,
            'default': m.default,
            'email': m.email,
            'addition_email_type': m.addition_email_type,
            'additional_email': m.additional_email,
            'address_type': m.address_type,
            'address_1':add1,
            'address_2':add2,
            'address_3': add3,
            'address_city': m.address_city,
            'address_county_state': m.address_county_state,
            'st_prm_add_country': m.st_prm_add_country,
            'st_prm_add_pstcode': m.st_prm_add_pstcode,
            'phone_number_type': m.phone_number_type,
            'phone_country_code': m.phone_country_code,
            'phone_number': m.phone_number,
            'mobile_country_code': m.mobile_country_code,
            'mobile_number': m.mobile_number,
            'Nationality': m.Nationality,
            'industry_experience': m.industry_experience,
            'note_category': m.note_category,
            'notes': m.notes,
            'deceased': m.deceased,
            'deceased_date': m.deceased_date,
            'education_institution': m.education_institution,
            'education_start_date': m.education_start_date,
            'education_end_date': m.education_end_date,
            'education_subject': m.education_subject,
            'education_level_studied': m.education_level_studied,
            'education_country': m.education_country,
            'education_course': m.education_course,
            'work_employer': m.work_employer,
            'work_industry': m.work_industry,
            'work_start_date': m.work_start_date,
            'work_end_date': m.work_end_date,
            'work_position': m.work_position,
            'individual_letter_salutation': m.individual_letter_salutation,
            'individual_envelope_label_salutation': m.individual_envelope_label_salutation,
            'School_name_custom_value': m.School_name_custom_value,
            'Status_custom_value': m.Status_custom_value,
            'student_no': m.stud_no,

          };

          finalExportList.push(tempRow);
        });
      }


      let finalRelationshipExportList = [];
      if (this.relationshipDetailList.length > 0) {
        this.relationshipDetailList.forEach((m, index) => {

          let tempRow = {
            'party1_id': m.party1_id,
            'party1_reference': m.party1_reference,
            'party2_id': m.party2_id,
            'party2_reference': m.party2_reference,
            'relationship': m.relationship,
          };

          finalRelationshipExportList.push(tempRow);
        });
      }
      if (this.selectedSchool !== ""){

        this.filterList[0].optionList.forEach(e => {
          if (e.id === this.selectedSchool){

          }
          }

        );
      }

      let dateSplit = this.dateRange.split(',')
      let fileName =  "Alumni withdrawals "+dateSplit[0]+" to "+dateSplit[1];
      if (this.selectedSchool !== ""){

        this.filterList[0].optionList.forEach(e => {
            if (e.SchoolID === this.selectedSchool){
              fileName +=" "+ e.SchoolName ;
            }
          }

        );
      }
      let fileNameRelationship =fileName+ " relationship" ;

      Export_CSV.CsvExport(finalExportList, '', '', fileName );
      Export_CSV.CsvExport(finalRelationshipExportList, '', '', fileNameRelationship); */
    },
  },
}
</script>

<style scoped></style>
